export default "__VITE_ASSET__BB_Ix68t__"